/** Cloud Function endpoint for the Mac-mini bidding agent. */
export const BIDDING_AGENT_ENDPOINT =
  'https://us-central1-lctf-projects.cloudfunctions.net/biddingAgentApi';

/**
 * Opens the bidding agent API schema JSON in a new tab.
 */
export function openBiddingAgentSchema(): void {
  window.open('/docs/agents/biddingAgent.json', '_blank', 'noopener,noreferrer');
}

/**
 * Downloads the bidding agent API schema JSON.
 */
export async function downloadBiddingAgentGuide(): Promise<void> {
  const url = `${process.env.PUBLIC_URL || ''}/docs/agents/biddingAgent.json`;
  const date = new Date().toISOString().slice(0, 10);
  const filename = `bidding-agent-schema-${date}.json`;

  try {
    const res = await fetch(url);
    if (res.ok) {
      const json = await res.text();
      const blob = new Blob([json], { type: 'application/json;charset=utf-8' });
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(blobUrl);
      return;
    }
  } catch {
    /* fall through */
  }

  window.open(url, '_blank', 'noopener,noreferrer');
}
